'use client';
import {
  InfoCircleOutlined,
} from '@ant-design/icons';
import dynamic from 'next/dynamic';
import React, { useState } from 'react';

const UserCart = dynamic(() => import('./cart/cart'), {
  ssr: false,
});

const RightIcons: React.FC = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const hideModal = () => {
    setIsModalVisible(false);
  };
  return (
    <div className="flex space-x-6">
      {/* 'Đặt Lịch' removed per request */}
    
      <div className="text-gray-600 cursor-pointer">
        <UserCart />
      </div>
      {isModalVisible && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div
            className={`bg-white w-[1200px] h-[500px] relative transform transition-all duration-500 ease-in-out ${isModalVisible
                ? 'translate-x-0 opacity-100'
                : 'translate-x-full opacity-0'
              }`}
          >
            <div className="flex justify-between h-[50px]  items-center bg-[#81d8d0]">
              <button
                onClick={hideModal}
                className="absolute top-2 right-5 text-gray-500 hover:text-black transition duration-200 text-lg"
              >
                ✕
              </button>
            </div>
            <div className="">
              <div className=" grid grid-cols-2">
                {/* Cột trái */}
                <div>
                  <div className="border-r border-b border-gray-300 h-[50px] flex items-center justify-center text-center text-[16px]">
                    Select a store
                    {/* Thêm nội dung khác cho cột trái */}
                  </div>
                  <div className="border-r border-b border-gray-300 h-[50px] flex items-center px-4">
                    <select
                      id="store-select"
                      className="border border-gray-500 px-2 py-1 focus:outline-none focus:ring-2 focus:ring-[#81C6B6] w-full "
                    >
                      <option value="" className="text-[10px]">
                        Choose a store
                      </option>
                      <option value="store1" className="text-[10px]">
                        TPHCM
                      </option>
                      <option value="store2" className="text-[10px]">
                        Ha Noi
                      </option>
                      <option value="store3" className="text-[10px]">
                        Da Nang
                      </option>
                    </select>
                  </div>
                </div>

                {/* Cột phải */}
                <div className="pl-4 border-b border-gray-300 h-[50px]"></div>
              </div>

              {/* Add inputs or forms if required */}
            </div>

            {/* Modal Footer */}
            <div className="grid grid-cols-2 h-[350px]">
              <div className="border-r border-gray-300 flex flex-col items-center justify-center text-center">
                {/* Icon với màu #81d8d0 và kích thước lớn */}
                <InfoCircleOutlined className="text-[#81d8d0] text-[50px] mb-2" />
                {/* Text bên dưới icon */}
                <div className="text-lg">Select a geographical area</div>
              </div>

              <div className="flex flex-col items-center justify-center text-center">
                Select a store to continue
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RightIcons;
